import { Controller, useFormContext } from "react-hook-form";

function DropdownField({
  name,
  label,
  options,
  fullWidth,
  required,
  requiredText = "This field is required",
  validation,
  placeholder = "Select an option",
}) {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const rules = {
    ...(required && { required: requiredText }),
    ...(validation && { validate: validation }),
  };

  return (
    <fieldset>
      {label && (
        <label>
          {label}
          {!required && <span className="label-optional"> (Optional)</span>}
        </label>
      )}
      <div className={`dropdown-field${fullWidth ? " full-width" : ""}`}>
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <select
              {...field}
              className="dropdown-select"
              aria-label={label}
              value={field.value === undefined ? "" : field.value}
            >
              <option value="" disabled>
                {placeholder}
              </option>
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          )}
        />
      </div>
      <span className="input-error">{errors?.[name]?.message}</span>
    </fieldset>
  );
}

export default DropdownField;
